import { useSyncExternalStore } from 'react';

/**
 * Скорость проигрывания звука — одна на весь сайт (Алексей 30.09, #1223: «в плеере
 * в разделе данные, да и везде, нужен 2x режим»). Держится в localStorage, читают
 * её все плееры: точный (lib/exactPlayer.ts), отрезки сводки (lib/snippetPlayer.ts),
 * цепочка <audio> разговора и плеер клипа в разметке.
 */
export const RATES = [1, 1.5, 2] as const;
export type Rate = (typeof RATES)[number];
const KEY = 'audioRate';

function read(): Rate {
  try {
    const v = Number(localStorage.getItem(KEY));
    return (RATES as readonly number[]).includes(v) ? (v as Rate) : 1;
  } catch {
    return 1;
  }
}

let rate: Rate = read();
const subs = new Set<() => void>();

export function getRate(): Rate {
  return rate;
}

export function setRate(r: Rate): void {
  rate = r;
  try { localStorage.setItem(KEY, String(r)); } catch { /* приватное окно */ }
  subs.forEach((f) => f());
}

export function cycleRate(): Rate {
  const i = RATES.indexOf(rate);
  const next = RATES[(i + 1) % RATES.length];
  setRate(next);
  return next;
}

export function subscribeRate(f: () => void): () => void {
  subs.add(f);
  return () => { subs.delete(f); };
}

export function useRate(): Rate {
  return useSyncExternalStore(subscribeRate, getRate, getRate);
}

/** Подпись кнопки: «1×», «1.5×», «2×». */
export function rateLabel(r: Rate): string {
  return `${r}×`;
}
